import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Dialog, Grid, IconButton, } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import "./style.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;
const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

function PDFSingleViewer(props) {
  const { currentPDF, openPDFModal, onClose} = props;


  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  /* For multi paged iteration, see this example
https://github.com/wojtekmaj/react-pdf/blob/master/sample/parcel/Sample.jsx
  */
  return (
    <Dialog fullScreen open={openPDFModal} onClose={onClose} className="attatchmentWidth">
      <Grid item>
        <IconButton aria-label="Close" onClick={onClose} className="PDFIconClose">
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid item>
        <Document
        // className={pdfRes}
        className="PDFCanvas"
          file={currentPDF}
          onLoadSuccess={onDocumentLoadSuccess}
          options={options}
          
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} />
          ))}
        </Document>
      </Grid>
    </Dialog>
  );
}

export default PDFSingleViewer;
